/* eslint-disable @typescript-eslint/no-unsafe-type-assertion -- for now */
/* eslint-disable @typescript-eslint/prefer-destructuring -- for now */
//src/config/apiConfig.ts
/**
 * API configuration for network requests.
 *
 * Uses Vite's built-in environment variable handling.
 * Variables must be prefixed with VITE_ to be exposed to the browser.
 */

const env = import.meta.env;
const apiBaseUrl = env.VITE_API_BASE_URL as string;
const portalBaseUrl = env.VITE_PORTAL_BASE_URL as string;

// --- Default headers ---
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
} as const;

// --- Exported config ---
export const API_CONFIG = {
  baseURL: apiBaseUrl,
  defaultHeaders: DEFAULT_HEADERS,
  withCredentials: true,
} as const;

export const PORTAL_URL = portalBaseUrl;
